export enum Permissions {
  COMMUNITY_OUTREACH = 'community_outreach',
  CDC_TIER1_METRICS = 'cdc_tier1_metrics',
  GENETIC_COUNSELING = 'genetic_counseling',
  GENETIC_COUNSELING__CREATE = 'genetic_counseling.create',
  STUDY_INSIGHTS__RECRUITMENT_LAYOUT_1 = 'study_insights.recruitment_layout_1',
  STUDY_INSIGHTS__RECRUITMENT_LAYOUT_2 = 'study_insights.recruitment_layout_2',
  STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3 = 'study_insights.recruitment_layout_3',
  CAMPAIGN_TRACKING = 'campaign_tracking',
  CAN_VIEW_PHI = 'can_view_phi',
  FAILURE_REASON = 'failure_reason',
}

export type PartnerPermission = Record<string, Permissions[]>;
